// SA-3
import type { ShiftRecord } from '../types/records'

const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/

export function isValidShiftTime(value: string): boolean {
  return TIME_RE.test(value.trim())
}

export function formatShiftTimeRange(shift: Pick<ShiftRecord, 'startTime' | 'endTime'>): string {
  return `${shift.startTime} – ${shift.endTime}`
}

export function shiftActiveLabel(active: boolean): string {
  return active ? 'Активна' : 'Неактивна'
}

/** Смена с графиком 5/2 (будни). */
export function isShift5_2(shift: Pick<ShiftRecord, 'name'>): boolean {
  return shift.name.includes('5/2')
}

/** Смена ротации 2/2 (не 5/2). */
export function isRotationShift(shift: Pick<ShiftRecord, 'name'>): boolean {
  return !isShift5_2(shift)
}
